import React from "react";
import { FaFileAlt } from "react-icons/fa";

const MoveModal = ({ folders = [], selectedFile, onClose, onMove }) => {
  return (
    <div className="fixed inset-0 bg-black bg-opacity-20 z-50 flex justify-center items-center px-4">
      <div className="bg-white rounded-xl p-6 w-[500px] h-[500px] ">
        {/* Modal Header */}
        <h2 className="text-xl font-bold text-secondary mb-4">
          Move to “{selectedFile?.name || "File"}”
        </h2>

        {/* Folders to move to */}
       

        {/* Current location display */}
      <div className=" mt-5">
       <p className=" text-secondary font-normal ">
          Current Location: MG Footage
        </p>
      </div>

        {/* Static Quick Locations */}
        <div className=" mt-3">
          <span className="text-primary font-medium ">All Locations</span>
           </div>
           <div className=" mt-3">
            <hr/>
           </div>
          <div className=" mt-5">
            <div className="space-y-3 mb-4">
            <div className="flex items-center gap-2  text-secondary mt-3 w-10 h-10">
             <img
                src="/assets/files.png"
                alt="Safe Folder"
                className=" w-full "
              />
              <span className=" text-nowrap">My Drive</span>
              
            </div>
            <div className="flex items-center gap-2  text-secondary mt-3 w-10 h-10">
              <img
                src="/assets/safe folder.png"
                alt="Safe Folder"
                className=" w-full "
              />
              <span className=" text-nowrap">Safe Folder</span>
            </div>
            <div className="flex items-center gap-2   text-secondary mt-3 w-10 h-10">
              <img
                src="/assets/recent.png"
                alt="Starred"
                className="w-full "
              />
              <span>Starred</span>
            </div>
          </div>
          </div>
         <div className=" mt-[10%]">
           <hr />
         </div>
          <p className="text-secondary mt-3 font-medium">Select a folder to move the file.</p>
      

        {/* Footer Buttons */}
        <div className="mt-6 flex justify-end gap-4">
          <button
            onClick={onClose}
            className="px-4 py-2 rounded-md text-primary font-medium "
          >
            Cancel
          </button>
          <button
            onClick={onClose}
            className="px-5 py-2 rounded-md text-secondary border font-medium"
          >
            Move
          </button>
        </div>
      </div>
    </div>
  );
};

export default MoveModal;
